import { OPEN_IN_NEW_TAB } from '@query/shared';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemButton,
  Typography,
} from '@mui/material';

export interface HistoryDialogProps {
  open: boolean;
  entries: Array<[string, string, string]>;
  titleCurrent: string;
  newTab: boolean;
  onToggleNewTab: () => void;
  onSelect: (index: number) => void;
  onClose: () => void;
}

/**
 * Диалог истории запросов — перенос historyListDialog (AppFC.kt:199-243).
 *
 * Подсветка выбранной строки сделана классом Mui-selected, как в оригинале:
 * проп selected у ListItemButton в связке с MUI 7 давал другую подсветку.
 */
export function HistoryDialog({
  open,
  entries,
  titleCurrent,
  newTab,
  onToggleNewTab,
  onSelect,
  onClose,
}: HistoryDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Queries History</DialogTitle>
      <DialogContent>
        <List>
          {entries.map(([, , heading], index) => (
            <ListItem key={`${index}-${heading}`} disablePadding>
              <ListItemButton
                className={heading === titleCurrent ? 'Mui-selected' : ''}
                onClick={() => onSelect(index)}
              >
                <Typography>{heading}</Typography>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <DialogActions>
          <Checkbox checked={newTab} onChange={onToggleNewTab} />
          <Typography>{OPEN_IN_NEW_TAB}</Typography>
          <Button onClick={onClose}>Cancel</Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}
